import { type Maybe, StudentStatus } from '@lingoda/monolith-graphql';

export const isLessonStatusAttended = (lesson: Maybe<{ studentStatus: StudentStatus }>) =>
    lesson
        ? [StudentStatus.Completed, StudentStatus.Pending, StudentStatus.Booked].includes(
              lesson.studentStatus,
          )
        : false;
